import React from 'react';
import { useLocation } from 'react-router-dom';
import List from '@sv-support-sdk/ui-components/src/components/Lists/List';

import NavItem from '../NavItem';

import { useAppSelector } from '../../../store/hooks';
import { $l } from '../../../locales';
import { routes } from '../../../routing';
import { selectUnreadMessages } from '../../../store/selectors/tickets';
import css from './style.module.scss';
import { WORKFLOW_FRONT_URL } from '../../../config';
import useMobileDetect from '../../../hooks/useMobileDetect';
import { userAuthorizedSelector } from '../../../store/selectors/user';
import {
  SUPPORT_NAV_ITEM_FAQ,
  SUPPORT_NAV_ITEM_GUIDES,
  SUPPORT_NAV_ITEM_LOG_OUT,
  SUPPORT_NAV_ITEM_RELEASE_NOTES,
} from '../../../constants/qaAttributes';

interface IProps {
  onMenuClick?: () => void;
}

const navigation = [
  {
    icon: '24--article',
    name: $l('SIDEBAR.GUIDES'),
    link: routes.$root,
    hideOnMobile: false,
    qaTag: SUPPORT_NAV_ITEM_GUIDES,
  },
  {
    icon: '24--live-help',
    name: $l('SIDEBAR.FAQ'),
    link: routes.faq,
    hideOnMobile: false,
    qaTag: SUPPORT_NAV_ITEM_FAQ,
  },
  {
    icon: '24--new-releases',
    name: $l('SIDEBAR.RELEASE_NOTES'),
    link: routes.releaseNotes,
    hideOnMobile: false,
    qaTag: SUPPORT_NAV_ITEM_RELEASE_NOTES,
  },
];

const Menu: React.FC<IProps> = ({ onMenuClick }) => {
  const isMobile = useMobileDetect();
  const location = useLocation();
  const ticketUnreadMessages = useAppSelector(selectUnreadMessages);
  const isAuthorized = useAppSelector(userAuthorizedSelector);

  const { pathname = '' } = location || {};

  const isPathNameIsActive = (link: string) => {
    if (link === routes.$root) {
      return pathname === routes.$root || pathname.includes(routes.articles);
    }

    return pathname.includes(link);
  };

  const authUrl = `${WORKFLOW_FRONT_URL}/${isAuthorized ? 'logout' : 'login'}?redirect=${window.location.href}`;

  return (
    <div className={css.sidebarMenu}>
      <List gap="4" height="full">
        {navigation.map(({ icon, name, link, hideOnMobile, qaTag }, idx) => {
          if (hideOnMobile && isMobile) return null;

          return (
            <NavItem
              key={idx}
              link={link}
              size={isMobile ? 'lg' : 'md'}
              icon={icon}
              text={name}
              onClick={onMenuClick}
              selected={isPathNameIsActive(link)}
              withNoticeDot={link === routes.tickets && !!ticketUnreadMessages.length}
              qaTag={qaTag}
            />
          );
        })}
      </List>
      {isMobile && (
        <List gap="4">
          <NavItem
            link={authUrl}
            icon={isAuthorized ? '24--logout' : '24--login'}
            text={isAuthorized ? $l('HEADER.LOG_OUT') : $l('HEADER.LOG_IN')}
            qaTag={SUPPORT_NAV_ITEM_LOG_OUT}
          />
        </List>
      )}
    </div>
  );
};

export default Menu;
